export const parseDday = (dday?: string): number | undefined => {
  if (!dday) return undefined;

  // "마감일" 문자열은 D-0과 동일
  if (dday === '마감일') return 0;

  // "마감" 문자열은 이미 지난 마감
  if (dday === '마감') return -1;

  // "D-39" 형식에서 숫자만 추출
  const match = dday.match(/D-?(\d+)/);
  if (!match) return undefined;

  return Number.parseInt(match[1], 10);
};

export const getDdayText = (dday: number): string => {
  if (dday > 0) return `마감 D-${dday}`;

  if (dday === 0) return '오늘 마감';

  return '마감';
};

export const isAvailablePolicy = (dday?: string): boolean => {
  const parsed = parseDday(dday);

  return parsed !== undefined && parsed >= 0;
};

export const isDeadlinePolicy = (dday?: string): boolean => {
  const parsed = parseDday(dday);

  return parsed !== undefined && parsed >= 0 && parsed <= 7;
};

export const getDdayColorClass = (parsedDday: number): string => {
  if (parsedDday >= 0 && parsedDday <= 7) return 'text-R-400';
  if (parsedDday < 0) return 'text-Gray-500';

  return 'text-Gray-900';
};
